<template>
    <div>
        <PublishingStatisticsCreateNewFavoriteDialog />
        <DeletionDialog :useContextSetinVuex="true" />
        <ValidationObserver
            ref="publishingStatisticsValidation"
            v-slot="{ passes }"
        >
            <v-container
                class="pt-0 pb-0"
                fluid
                style="background-color: var(--v-listPageBackground-base);"
            >
        <v-row style="background-color: var(--v-listPageHeadlineBackground-base);">
            <v-col
                class="headline"
                :alvqa="alvqa + '-list-title'"
            >
                {{ $t('lang_PUBLISHING_STATISTICS') }}
            </v-col>
        </v-row>

        <!-- Row 1: search + publishing filters (max 4) -->
        <v-row class="my-0" style="background-color: var(--v-listPageFilterBackground-base);">
            <v-col class="py-0">
                <SearchFilter
                    :context="context"
                    :alvqa="alvqa + '-list-textfield-search'"
                    @keydown.enter="passes(publishingStatisticReport)"
                    label="lang_GENERIC_WORKS_PLURAL"
                />
            </v-col>
            <v-col class="py-0">
                <DropdownFilter
                    :context="context + 'RightsType'"
                    field="RightsType"
                    label="lang_PUBLISHING_STATISTICS_CAPTION_TYPE_OF_RIGHTS"
                    :items="rightsTypeValues"
                    :alvqa="alvqa + '-list-dropdown-rights-type'"
                    :multiple="true"
                    :withMargin="false"
                    :allSelect="false"
                    rules="required"
                />
            </v-col>
            <v-col class="py-0">
                <!-- <BaseEditPageAutocomplete
                    v-if="!isByLicensor"
                    :context="context"
                    field="Rightsholder"
                    :label="$t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACTING_PARTY')"
                    :withMargin="false"
                    :multiple="false"
                    :withFreeText="false"
                    :isLoading="true"
                    :returnObject="true"
                    :disabled="true"
                    rules=""
                    :alvqa="alvqa + '-list-dropdown-rightsholder'"
                >
                    <template v-slot:selection="{ item }">
                        <span v-if="item && item.rightsholder">
                            {{ $alvPlugin.showNameOfAzEntry(item.rightsholder, true) + ' (' + item.rightsholder.alvId + ')' }}
                        </span>
                        <span v-else-if="item">
                            {{ $alvPlugin.showNameOfAzEntry(item, true) + ' (' + item.alvId + ')' }}
                        </span>
                    </template>
                    <template v-slot:items="{ items }">
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $alvPlugin.showNameOfAzEntry(items.rightsholder, true) + ' (' + items.rightsholder.alvId + ')' }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>
                </BaseEditPageAutocomplete> -->
                <BaseEditPageAutocomplete
                    :context="context"
                    field="Licensor"
                    :label="$t('lang_GENERIC_CAPTION_LICENSOR')"
                    :withMargin="false"
                    :multiple="false"
                    :withFreeText="false"
                    :returnObject="true"
                    :disabled="!isByLicensor"
                    rules=""
                    :alvqa="alvqa + '-list-dropdown-licensor'"
                >
                    <template v-slot:selection="{ item }">
                        <span v-if="item && item.licensor">
                            {{ $alvPlugin.showNameOfAzEntry(item.licensor, true) + ' (' + item.licensor.alvId + ')' }}
                        </span>
                        <span v-else-if="item">
                            {{ $alvPlugin.showNameOfAzEntry(item, true) + ' (' + item.alvId + ')' }}
                        </span>
                    </template>
                    <template v-slot:items="{ items }">
                        <v-list-item-content>
                            <v-list-item-title v-if="items && items.licensor">
                                {{ $alvPlugin.showNameOfAzEntry(items.licensor, true) + ' (' + items.licensor.alvId + ')' }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>
                </BaseEditPageAutocomplete>
            </v-col>
            <!-- REGIONS -->
            <v-col class="py-0">
                <RegionsDialog
                    :context="context"
                    activatorAlvqa="publishing-statistics-textfield-regions"
                />
            </v-col>
            <span class="pt-4">
                <BaseIcon/>
            </span>
        </v-row>

        <!-- Row 2: period + rights (max 4, months first like Label Statistics) -->
        <v-row class="my-0">
            <v-col class="py-0">
                <v-menu
                    ref="fromMonthMenu"
                    min-width="auto"
                    offset-y
                    :close-on-content-click="false"
                    :return-value.sync="fromValue"
                    v-model="fromMonthMenu"
                >
                    <template v-slot:activator="{ on }">
                        <ValidationProvider
                            name="toMonth"
                            rules="required|publishingStatisticsCheckToFromMonthOrder"
                            v-slot="{ errors }"
                            slim
                        >
                            <v-text-field
                                v-on="on"
                                :value="getFormattedDateFrom"
                                :label="$t('lang_LABEL_STATISTICS_CAPTION_FROM_MONTH')"
                                @click:clear="resetFromValue()"
                                readonly
                                clearable
                                :loading="loading"
                                :alvqa="alvqa + '-textfield-from-month'"
                                :error-messages="errors"
                            ></v-text-field>
                        </ValidationProvider>
                    </template>
                    <v-date-picker
                        v-model="fromValue"
                        :locale="$i18n.locale"
                        color="buttonStandard"
                        no-title
                        type="month"
                        :alvqa="alvqa + '-datepicker-from-month'"
                    >
                        <v-spacer></v-spacer>
                        <BaseButton
                            class="text-center"
                            label="lang_GENERAL_BUTTON_CANCEL"
                            @click="fromMonthMenu = false"
                            :alvqa="alvqa + '-button-cancel-from-month'"
                        />
                        <BaseButton
                            class="text-center"
                            label="lang_GENERAL_BUTTON_OK"
                            @click="$refs.fromMonthMenu.save(fromValue)"
                            :alvqa="alvqa + '-button-ok-from-month'"
                        />
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col class="py-0">
                <v-menu
                    ref="toMonthMenu"
                    min-width="auto"
                    offset-y
                    :close-on-content-click="false"
                    :return-value.sync="toValue"
                    v-model="toMonthMenu"
                >
                    <template v-slot:activator="{ on }">
                        <ValidationProvider
                            name="fromMonth"
                            rules="required|publishingStatisticsCheckToFromMonthOrder"
                            v-slot="{ errors }"
                            slim
                        >
                            <v-text-field
                                v-on="on"
                                :value="getFormattedDateTo"
                                :label="$t('lang_LABEL_STATISTICS_CAPTION_TO_MONTH')"
                                readonly
                                @click:clear="resetToValue()"
                                clearable
                                :loading="loading"
                                :alvqa="alvqa + '-textfield-to-month'"
                                :error-messages="errors"
                            ></v-text-field>
                        </ValidationProvider>
                    </template>
                    <v-date-picker
                        v-model="toValue"
                        :locale="$i18n.locale"
                        color="buttonStandard"
                        no-title
                        type="month"
                        :alvqa="alvqa + '-datepicker-to-month'"
                    >
                        <v-spacer></v-spacer>
                        <BaseButton
                            class="text-center"
                            label="lang_GENERAL_BUTTON_CANCEL"
                            @click="toMonthMenu = false"
                            :alvqa="alvqa + '-button-cancel-to-month'"
                        />
                        <BaseButton
                            class="text-center"
                            label="lang_GENERAL_BUTTON_OK"
                            @click="$refs.toMonthMenu.save(toValue)"
                            :alvqa="alvqa + '-button-ok-to-month'"
                        />
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col class="py-0">
                <DropdownFilter
                    :context="context + 'Sources'"
                    field="Sources"
                    label="lang_GENERIC_CAPTION_SOURCE"
                    :items="sourceItems"
                    :alvqa="alvqa + '-list-dropdown-sources'"
                    :multiple="true"
                    :withMargin="false"
                    :allSelect="true"
                />
            </v-col>
            <v-col class="py-0">
                <!-- <DropdownFilter
                    :context="context + 'Contracts'"
                    field="Contracts"
                    label="lang_GENERIC_CONTRACTS_CAPTION_CONTRACT_TYPE"
                    :items="contractTypeItems"
                    :alvqa="alvqa + '-list-dropdown-contracts'"
                    :multiple="true"
                    :withMargin="false"
                    :disabled="true"
                /> -->
            </v-col>
            <span class="py-0 d-flex align-center">
                <BaseIcon
                    :alvqa="alvqa + '-list-icon-excel'"
                    @click="exportExcel"
                    icon="fa-file-excel"
                    :disabled="exportInProgress || loading"
                    :loading="exportInProgress"
                    tooltipText="lang_GENERAL_STATISTICS_CAPTION_GENERATE_EXCEL"
                />
            </span>
        </v-row>

        <!-- Row 3: chart / table controls -->
        <v-row class="my-0">
            <v-col class="py-0">
                <DropdownFilter
                    :context="context + 'LeftChart'"
                    field="LeftChart"
                    label="lang_LABEL_STATISTICS_CAPTION_LEFT_CHART"
                    :items="leftChartValues"
                    :alvqa="alvqa + '-list-dropdown-left-chart'"
                    :multiple="false"
                    :withMargin="false"
                    :additionalFunction="refreshChartDisplay"
                    rules="required"
                />
            </v-col>
            <v-col class="py-0">
                <DropdownFilter
                    :context="context + 'RightChart'"
                    field="RightChart"
                    label="lang_LABEL_STATISTICS_CAPTION_RIGHT_CHART"
                    :items="rightChartValues"
                    :alvqa="alvqa + '-list-dropdown-right-chart'"
                    :multiple="false"
                    :withMargin="false"
                    :additionalFunction="refreshChartDisplay"
                    rules="required"
                />
            </v-col>
            <v-col class="py-0">
                <DropdownFilter
                    :context="context + 'DataTable'"
                    field="DataTable"
                    label="lang_LABEL_STATISTICS_CAPTION_DATA_TABLE"
                    :items="dataTableValues"
                    :alvqa="alvqa + '-list-dropdown-data-table'"
                    :multiple="false"
                    :withMargin="false"
                    :additionalFunction="onDataTableChange"
                    rules="required"
                />
            </v-col>
            <v-col class="py-0">
                <BaseDropdown 
                    :items="favoriteItems"
                    :label="$t('lang_GENERAL_FAVOURITE')"
                    :context="context+'Favorite'"
                    :hideDetails="true"
                    :returnObject="true"
                    :clearable="true"
                    :item-value="statisticsFavoriteItemValue"
                    :alvqa="alvqa + '-list-favorit-dropdown'"
                />
            </v-col>
            <span class="py-0 d-flex align-center">
                <BaseIcon
                    :alvqa="alvqa + '-list-icon-search'"
                    @click="passes(publishingStatisticReport)"
                    icon="fa-search"
                    :disabled="loading || exportInProgress"
                    :loading="loading"
                    tooltipText="lang_GENERAL_CAPTION_START_SEARCH"
                />
            </span>
        </v-row>

        <!-- Charts + cards -->
        <v-row style="background-color: var(--v-listPageHeadlineBackground-base);" v-if="showChartsSection" class="mt-4">
            <v-col>
                <pie-chart :context="context + 'First'"></pie-chart>
            </v-col>
            <v-col class="d-flex flex-column">
                <v-row>
                    <v-col class="my-1">
                        <v-card elevation="2">
                            <div v-if="cards.firstCard" class="d-flex flex-column justify-center align-center" style="height: 100%;">
                                <v-card-title>
                                    {{ $alvPlugin.isLangConst(cards.firstCard.text) ? $t(cards.firstCard.text) : cards.firstCard.text }}
                                </v-card-title>
                                <v-card-text class="text-center">
                                    {{ $alvPlugin.formatMoney(cards.firstCard.value) }} {{ $store.getters.getSelectedCurrency }}
                                </v-card-text>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="my-1">
                        <v-card elevation="2" max-width="450">
                            <div v-if="cards.secondCard" class="d-flex flex-column justify-center align-center" style="height: 100%;">
                                <v-card-title>
                                    {{ $alvPlugin.isLangConst(cards.secondCard.text) ? $t(cards.secondCard.text) : cards.secondCard.text }}
                                </v-card-title>
                                <v-card-text class="text-center">
                                    {{ $alvPlugin.formatMoney(cards.secondCard.value) }} {{ $store.getters.getSelectedCurrency }}
                                </v-card-text>
                            </div>
                        </v-card>
                    </v-col>
                    <v-col class="my-1">
                        <v-card elevation="2" max-width="450">
                            <div v-if="cards.thirdCard" class="d-flex flex-column justify-center align-center" style="height: 100%;">
                                <v-card-title>
                                    {{ $alvPlugin.isLangConst(cards.thirdCard.text) ? $t(cards.thirdCard.text) : cards.thirdCard.text }}
                                </v-card-title>
                                <v-card-text class="text-center">
                                    {{ $alvPlugin.formatMoney(cards.thirdCard.value) }} {{ $store.getters.getSelectedCurrency }}
                                </v-card-text>
                            </div>
                        </v-card>
                    </v-col>
                    <!-- <v-col class="my-1">
                        <v-card elevation="2" max-width="450">
                            <div v-if="cards.fourthCard" class="d-flex flex-column justify-center align-center" style="height: 100%;">
                                <v-card-title>
                                    {{ $alvPlugin.isLangConst(cards.fourthCard.text) ? $t(cards.fourthCard.text) : cards.fourthCard.text }}
                                </v-card-title>
                                <v-card-text class="text-center">
                                    {{ $alvPlugin.formatMoney(cards.fourthCard.value) }} {{ $store.getters.getSelectedCurrency }}
                                </v-card-text>
                            </div>
                        </v-card>
                    </v-col> -->
                </v-row>
            </v-col>
            <v-col>
                <pie-chart :context="context + 'Second'"></pie-chart>
            </v-col>
        </v-row>

        <!-- Data table -->
        <v-row style="background-color: var(--v-listPageHeadlineBackground-base);" v-if="showDataTable">
            <v-col
                class="headline"
                :alvqa="alvqa + '-data-table-title'"
            >
                {{ $alvPlugin.isLangConst(dataTableTitle) ? $t(dataTableTitle) : dataTableTitle }}
            </v-col>
            <v-col cols="12">
                <v-data-table
                    v-if="!isByLicensor"
                    :headers="headers"
                    :items="items"
                    :items-per-page="1000"
                    hide-default-footer
                    :header-props="{ sortIcon: '' }"
                    :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                    class="noMinWidth"
                >
                    <template v-for="(header, index) in headers" v-slot:[`header.${header.value}`]>
                        <span :alvqa="header.alvqa">{{ header.text }}</span>
                    </template>
                    <template v-slot:item="{ item }">
                        <tr>
                            <td class="caption text-center" :alvqa="alvqa + '-list-row-text-type'">
                                {{ $t(getWorksType(item.statusType)) }}
                            </td>
                            <td class="ellipsis" :alvqa="alvqa + '-list-row-text-title'">
                                <BaseTooltip :simpleText="item.title" />
                            </td>
                            <td class="ellipsis" :alvqa="alvqa + '-list-row-text-composers'">
                                <BaseTooltip :simpleText="item.composers" />
                            </td>
                            <td class="no_ellipsis text-right" :alvqa="alvqa + '-list-row-text-work-id'">{{ item.gemaNumber }}</td>
                            <td class="no_ellipsis text-right" :alvqa="alvqa + '-list-row-number-domestic'">{{ $alvPlugin.formatMoney(item.amountDomestic) }}</td>
                            <td class="no_ellipsis text-right" :alvqa="alvqa + '-list-row-number-foreign'">{{ $alvPlugin.formatMoney(item.amountForeign) }}</td>
                            <!-- <td class="no_ellipsis text-right" :alvqa="alvqa + '-list-row-number-licensing'">{{ $alvPlugin.formatMoney(item.amountDV) }}</td> -->
                            <td class="no_ellipsis text-right" :alvqa="alvqa + '-list-row-number-sum'">{{ $alvPlugin.formatMoney(item.amountTotal) }}</td>
                        </tr>
                    </template>
                </v-data-table>
                <v-data-table
                    v-else
                    :headers="licensorHeaders"
                    :items="licensorItems"
                    :expanded.sync="expandedLicensors"
                    @click:row="expandLicensorByClick($event)"
                    item-key="alvId"
                    show-expand
                    :loading="loading"
                    :items-per-page="licensorPageLimit"
                    hide-default-footer
                    :header-props="{ sortIcon: '' }"
                    :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                    :loading-text="$t('lang_GENERAL_LOADING_DATATABLE')"
                    class="noMinWidth"
                >
                    <template v-for="(header, i) in licensorHeaders" v-slot:[`header.${header.value}`]>
                        <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                    </template>
                    <template v-slot:[`item.data-table-expand`]="{ isExpanded }">
                        <v-icon
                            v-if="isExpanded"
                            small
                            class="ma-0 pa-0"
                            color="buttonStandard"
                            :alvqa="alvqa + '-list-row-expand-icon-open'"
                        >fa-arrow-alt-circle-down</v-icon>
                        <v-icon
                            v-else
                            small
                            class="ma-0 pa-0"
                            color="buttonStandard"
                            :alvqa="alvqa + '-list-row-expand-icon-close'"
                        >fa-arrow-alt-circle-right</v-icon>
                    </template>
                    <template v-slot:[`item.name`]="{ item }">
                        <div class="ellipsis" :alvqa="alvqa + '-list-row-text-licensor'">
                            <BaseTooltip :simpleText="item.name" />
                        </div>
                    </template>
                    <template v-slot:[`item.alvId`]="{ item }">
                        <div class="no_ellipsis" :alvqa="alvqa + '-list-row-text-alvid'">
                            {{ item.alvId }}
                        </div>
                    </template>
                    <template v-slot:[`item.worksCount`]="{ item }">
                        <div class="no_ellipsis text-right" :alvqa="alvqa + '-list-row-number-works-count'">
                            {{ licensorWorksCount(item) }}
                        </div>
                    </template>
                    <template v-slot:[`item.pr`]="{ item }">
                        <div class="no_ellipsis text-right" :alvqa="alvqa + '-list-row-number-pr'">
                            {{ $alvPlugin.formatMoney(item.pr) }}
                        </div>
                    </template>
                    <template v-slot:[`item.mr`]="{ item }">
                        <div class="no_ellipsis text-right" :alvqa="alvqa + '-list-row-number-mr'">
                            {{ $alvPlugin.formatMoney(item.mr) }}
                        </div>
                    </template>
                    <template v-slot:[`item.sum`]="{ item }">
                        <div class="no_ellipsis text-right" :alvqa="alvqa + '-list-row-number-sum'">
                            {{ $alvPlugin.formatMoney(item.sum) }}
                        </div>
                    </template>
                    <template v-slot:expanded-item="{ item }">
                        <td
                            colspan="1"
                            style="background-color: var(--v-expandPanelBackground-base);"
                        ></td>
                        <td
                            class="pl-0"
                            :colspan="licensorHeaders.length - 1"
                            style="background-color: var(--v-expandPanelBackground-base);"
                        >
                            <v-container fluid class="pl-0 pr-0">
                                <v-row class="align-center px-2 pt-2 pb-1">
                                    <v-col class="py-0">
                                        <span :alvqa="alvqa + '-list-row-text-works-total'">
                                            {{ $t('lang_GENERIC_CAPTION_NUMBER_OF_WORKS') }}: {{ licensorWorksCount(item) }}
                                        </span>
                                    </v-col>
                                    <v-col
                                        v-if="hasLicensorWorksOverflow(item)"
                                        class="py-0 text-right"
                                    >
                                        <v-btn
                                            text
                                            color="buttonStandard"
                                            class="text-none"
                                            min-height="44"
                                            :alvqa="alvqa + (isShowAllLicensorWorks(item) ? '-button-show-less-works' : '-button-show-all-works')"
                                            @click="toggleShowAllLicensorWorks(item)"
                                        >
                                            {{ showAllWorksLabel(item) }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pr-0">
                                        <v-data-table
                                            :headers="licensorWorkHeaders"
                                            :items="visibleLicensorWorks(item)"
                                            item-key="alvId"
                                            :items-per-page="-1"
                                            :disable-sort="hasLicensorWorksOverflow(item) && !isShowAllLicensorWorks(item)"
                                            hide-default-footer
                                            :header-props="{ sortIcon: '' }"
                                            :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                                            class="noMinWidth"
                                        >
                                            <template v-for="(header, i) in licensorWorkHeaders" v-slot:[`header.${header.value}`]>
                                                <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`item.title`]="{ item }">
                                                <div class="ellipsis" :alvqa="alvqa + '-list-row-text-work-title'">
                                                    <BaseTooltip :simpleText="item.title" />
                                                </div>
                                            </template>
                                            <template v-slot:[`item.pr`]="{ item }">
                                                <div class="no_ellipsis text-right" :alvqa="alvqa + '-list-row-number-work-pr'">
                                                    {{ $alvPlugin.formatMoney(item.pr) }}
                                                </div>
                                            </template>
                                            <template v-slot:[`item.mr`]="{ item }">
                                                <div class="no_ellipsis text-right" :alvqa="alvqa + '-list-row-number-work-mr'">
                                                    {{ $alvPlugin.formatMoney(item.mr) }}
                                                </div>
                                            </template>
                                            <template v-slot:[`item.sum`]="{ item }">
                                                <div class="no_ellipsis text-right" :alvqa="alvqa + '-list-row-number-work-sum'">
                                                    {{ $alvPlugin.formatMoney(item.sum) }}
                                                </div>
                                            </template>
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </td>
                    </template>
                </v-data-table>
                <div
                    v-if="showLicensorPagination"
                    class="d-flex justify-center py-3"
                >
                    <v-pagination
                        :value="licensorPage"
                        :length="licensorNumberOfPages"
                        total-visible="10"
                        color="pagination"
                        :alvqa="alvqa + '-pagination'"
                        @input="onLicensorPageChange"
                    />
                </div>
            </v-col>
        </v-row>
    </v-container>
        </ValidationObserver>
    </div>
</template>

<script>
import PublishingStatisticsCreateNewFavoriteDialog from './_dialogs/PublishingStatisticsCreateNewFavoriteDialog'
import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import RegionsDialog from '@/components/_dialogs/RegionsDialog'
import BaseDropdown from '@/components/_base/BaseDropdown'
import DropdownFilter from '@/components/_filters/DropdownFilter'
import SearchFilter from '@/components/_filters/SearchFilter'
import BaseTooltip from '@/components/_base/BaseTooltip'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseButton from '@/components/_buttons/BaseButton'
import PieChart from '@/components/_highcharts/PieChart'
import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'
import {
    DropdownPublishingStatisticsRightsTypes,
    DropdownPublishingStatisticsLeftChart,
    DropdownPublishingStatisticsRightChart,
    DropdownPublishingStatisticsLicensorChart,
    DropdownPublishingStatisticsDataTable,
} from '@/assets/dropdowns/alvDropdowns.js'

const LICENSOR_WORK_PREVIEW_LIMIT = 10

export default {
    name: 'PublishingStatistics',
    components: {
        DropdownFilter,
        SearchFilter,
        BaseTooltip,
        BaseIcon,
        BaseButton,
        PieChart,
        BaseEditPageAutocomplete,
        RegionsDialog,
        BaseDropdown,
        PublishingStatisticsCreateNewFavoriteDialog,
        DeletionDialog,
    },
    data() {
        return {
            context: 'PublishingStatistics',
            alvqa: 'publishing-statistics',
            fromMonthMenu: false,
            toMonthMenu: false,
            expandedLicensors: [],
            showAllWorksByLicensor: {},
        }
    },
    computed: {
        getFormattedDateFrom() { return this.fromValue ? this.$d(new Date(this.fromValue), 'alvMonthYearFormat') : '' },
        getFormattedDateTo() { return this.toValue ? this.$d(new Date(this.toValue), 'alvMonthYearFormat') : '' },
        fromValue: {
            get() { return this.$store.getters.getSelectedPublishingStatisticsFrom },
            set(value) { this.$store.commit('setSelectedPublishingStatisticsFrom', value) },
        },
        toValue: {
            get() { return this.$store.getters.getSelectedPublishingStatisticsTo },
            set(value) { this.$store.commit('setSelectedPublishingStatisticsTo', value) },
        },
        loading: {
            get() { return this.$store.getters.getIsLoading },
            set(value) { this.$store.commit('setIsLoading', value) },
        },
        headers() {
            const rawHeaders = this.$store.getters.getPublishingStatisticsDatatableData.headers || []
            if (rawHeaders.length === 0) return []
            return rawHeaders.map((header) => {
                let textValue = this.$t(header.text)
                if (header.suffix) {
                    textValue += ' (' + header.suffix + ')'
                }
                if (header.value === 'amountTotal') {
                    textValue = this.$t('lang_GENERIC_CAPTION_SUM') + ' ' + this.$store.getters.getSelectedCurrency
                }
                return {
                    text: textValue,
                    value: header.value,
                    align: header.align,
                    sortable: header.sortable,
                    class: header.class,
                    alvqa: this.alvqa + '-list-header-' + header.value,
                }
            })
        },
        items() {
            return this.$store.getters.getPublishingStatisticsDatatableData.data || []
        },
        isByLicensor() {
            return this.$store.getters.getSelectedPublishingStatisticsDataTable === 'byLicensor'
        },
        licensorItems() {
            return this.$store.getters.getPublishingStatisticsLicensorRows || []
        },
        licensorHeaders() {
            const currency = this.$store.getters.getSelectedCurrency
            return [
                {
                    text: '',
                    value: 'data-table-expand',
                    align: 'center',
                    sortable: false,
                    width: '48px',
                    alvqa: this.alvqa + '-list-header-expand',
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_LICENSOR'),
                    value: 'name',
                    align: 'left',
                    sortable: true,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-list-header-licensor',
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_ALVID'),
                    value: 'alvId',
                    align: 'left',
                    sortable: true,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-list-header-alvid',
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_NUMBER_OF_WORKS'),
                    value: 'worksCount',
                    align: 'right',
                    sortable: false,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-list-header-works-count',
                },
                {
                    text: this.$t('lang_PUBLISHING_CAPTION_PERFORMING_RIGHTS_ABBREVIATION'),
                    value: 'pr',
                    align: 'right',
                    sortable: true,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-list-header-pr',
                },
                {
                    text: this.$t('lang_PUBLISHING_CAPTION_MECHANICAL_RIGHTS_ABBREVIATION'),
                    value: 'mr',
                    align: 'right',
                    sortable: true,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-list-header-mr',
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_SUM') + ' ' + currency,
                    value: 'sum',
                    align: 'right',
                    sortable: true,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-list-header-sum',
                },
            ]
        },
        licensorWorkHeaders() {
            const currency = this.$store.getters.getSelectedCurrency
            return [
                {
                    text: this.$t('lang_PUBLISHING_WORKS_CAPTION_INTERNATIONAL_WORK_TITLE'),
                    value: 'title',
                    align: 'left',
                    sortable: true,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-list-header-work-title',
                },
                {
                    text: this.$t('lang_PUBLISHING_CAPTION_PERFORMING_RIGHTS_ABBREVIATION'),
                    value: 'pr',
                    align: 'right',
                    sortable: true,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-list-header-work-pr',
                },
                {
                    text: this.$t('lang_PUBLISHING_CAPTION_MECHANICAL_RIGHTS_ABBREVIATION'),
                    value: 'mr',
                    align: 'right',
                    sortable: true,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-list-header-work-mr',
                },

                {
                    text: this.$t('lang_GENERIC_CAPTION_SUM') + ' ' + currency,
                    value: 'sum',
                    align: 'right',
                    sortable: true,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-list-header-work-sum',
                },
            ]
        },
        showDataTable() {
            if (this.isByLicensor) {
                return this.$store.getters.getPublishingStatisticsLicensorHasRun
            }
            const data = this.$store.getters.getPublishingStatisticsDatatableData.data
            return data && data.length > 0
        },
        dataTableTitle() {
            if (this.isByLicensor) {
                const key = 'lang_PUBLISHING_STATISTICS_DATATABLE_DROPDOWN_CONTRIBUTION_BY_LICENSOR'
                const translated = this.$t(key)
                const title = translated === key ? 'Contribution by Licensor' : translated
                return title
            }
            return this.$store.getters.getPublishingStatisticsDatatableData.title
        },
        licensorPage() {
            return this.$store.getters.getPublishingStatisticsLicensorPage || 1
        },
        licensorPageLimit() {
            return this.$store.getters.getPublishingStatisticsLicensorLimit || 50
        },
        licensorTotal() {
            return this.$store.getters.getPublishingStatisticsLicensorTotal || 0
        },
        licensorNumberOfPages() {
            const fromApi = this.$store.getters.getPublishingStatisticsLicensorNumberOfPages || 0
            if (fromApi) return fromApi
            const total = this.licensorTotal
            return total > 0 ? Math.ceil(total / this.licensorPageLimit) : 0
        },
        showLicensorPagination() {
            return this.isByLicensor && this.licensorNumberOfPages > 1
        },
        contractTypeItems() {
            this.$store.commit('setPublishingContractsTypes')
            const types = this.$store.getters.getPublishingContractsTypes
            if (!types) return []
            return types.map((type) => ({
                text: this.$alvPlugin.isLangConst(type.text) ? this.$t(type.text) : type.text,
                value: type.value,
                alvqa: type.alvqa,
            }))
        },
        sourceItems() {
            return (this.$store.getters.getAzForMappingsImport || [])
                .filter((source) => source.value !== 'erp-invoicing')
                .map((source) => ({
                    text: source.text,
                    value: source.value,
                    alvqa: 'publishing-statistics-source-' + source.value,
                }))
        },
        rightsTypeValues() {
            return DropdownPublishingStatisticsRightsTypes.map((type) => ({
                text: this.$t(type.text),
                value: type.value,
                alvqa: type.alvqa,
            }))
        },
        leftChartValues() {
            const source = this.isByLicensor
                ? DropdownPublishingStatisticsLicensorChart
                : DropdownPublishingStatisticsLeftChart
            return source.map((type) => {
                const translated = this.$t(type.text)
                return {
                    text: translated === type.text && type.fallback ? type.fallback : translated,
                    value: type.value,
                    alvqa: type.alvqa,
                }
            })
        },
        rightChartValues() {
            const source = this.isByLicensor
                ? DropdownPublishingStatisticsLicensorChart
                : DropdownPublishingStatisticsRightChart
            return source.map((type) => {
                const translated = this.$t(type.text)
                return {
                    text: translated === type.text && type.fallback ? type.fallback : translated,
                    value: type.value,
                    alvqa: type.alvqa,
                }
            })
        },
        dataTableValues() {
            return DropdownPublishingStatisticsDataTable.map((type) => {
                const translated = this.$t(type.text)
                return {
                    text: translated === type.text && type.fallback ? type.fallback : translated,
                    value: type.value,
                    alvqa: type.alvqa,
                }
            })
        },
        showChartsSection() {
            if (this.isByLicensor) {
                return this.$store.getters.getPublishingStatisticsLicensorHasRun
            }
            return this.$store.getters.getShowPublishingStatisticsChartsSection
        },
        cards() {
            return this.$store.getters.getPublishingStatisticsCards
        },
        favoriteItems() {
            const dropdownItems = JSON.parse(JSON.stringify(this.$store.getters.getPublishingStatisticsFavoriteDropdownValues))
            dropdownItems.forEach(element => {
                // translate "Add favorite" and "Delete favorite" options to selected UI lang
                element['text'] = this.$alvPlugin.isLangConst(element['text']) ? this.$t(element['text']) : element['text']

                // Set alvqas
                if(element.value === 'newFavorite') element['alvqa'] = this.alvqa + '-list-favorit-dropdown-new-favorite'
                else if(element.value === 'deleteFavorite') element['alvqa'] = this.alvqa + '-list-favorit-dropdown-delete-favorite'
                else element['alvqa'] = this.alvqa + '-list-favorit-dropdown-' + element['id']
            })
            return dropdownItems
        },
        exportInProgress() {
            return this.$store.getters.getPublishingStatisticsExportInProgress
        },
    },
    methods: {
        statisticsFavoriteItemValue(item) {
            return item.id != null ? item.id : item.value
        },
        resetFromValue() {
            this.$store.commit('setSelectedPublishingStatisticsFrom', null)
        },
        resetToValue() {
            this.$store.commit('setSelectedPublishingStatisticsTo', null)
        },
        getWorksType(type) {
            switch (type) {
                case 'opw': return 'lang_PUBLISHING_WORKS_DROPDOWN_TYPE_OPW'
                case 'spw': return 'lang_PUBLISHING_WORKS_DROPDOWN_TYPE_SPW'
                case 'upw': return 'lang_PUBLISHING_WORKS_DROPDOWN_TYPE_UPW'
                default: return 'lang_GENERAL_WORK'
            }
        },
        publishingStatisticReport() {
            if (this.isByLicensor) this.resetLicensorExpandState()
            this.$store.dispatch('publishingStatisticReport')
        },
        refreshChartDisplay() {
            if (this.isByLicensor) {
                this.$store.dispatch('refreshLicensorDisplay')
                return
            }
            this.$store.dispatch('refreshPublishingStatisticsDisplay')
        },
        onDataTableChange() {
            if (this.isByLicensor) {
                this.resetLicensorExpandState()
                this.$store.commit('setSelectedPublishingStatisticsLeftChart', 'byLicensor')
                this.$store.commit('setSelectedPublishingStatisticsRightChart', 'byRightsType')
                if (this.$store.getters.getPublishingStatisticsLicensorHasRun) {
                    this.$store.dispatch('refreshLicensorDisplay')
                }
                return
            }
            this.resetLicensorExpandState()
            const workKeys = ['bySources', 'byType', 'byRightsType']
            const left = this.$store.getters.getSelectedPublishingStatisticsLeftChart
            const right = this.$store.getters.getSelectedPublishingStatisticsRightChart
            if (!workKeys.includes(left)) {
                this.$store.commit('setSelectedPublishingStatisticsLeftChart', 'bySources')
            }
            if (!workKeys.includes(right)) {
                this.$store.commit('setSelectedPublishingStatisticsRightChart', 'byType')
            }
            this.refreshChartDisplay()
        },
        onLicensorPageChange(page) {
            if (page === this.licensorPage) return
            this.resetLicensorExpandState()
            this.$store.dispatch('fetchPublishingStatisticsByLicensor', { page })
        },
        expandLicensorByClick(item) {
            if (this.expandedLicensors.includes(item)) {
                const indexOfItem = this.expandedLicensors.indexOf(item)
                this.expandedLicensors.splice(indexOfItem, 1)
            } else {
                this.expandedLicensors.push(item)
            }
        },
        resetLicensorExpandState() {
            this.expandedLicensors = []
            this.showAllWorksByLicensor = {}
        },
        licensorWorksCount(item) {
            return (item && item.works) ? item.works.length : 0
        },
        hasLicensorWorksOverflow(item) {
            return this.licensorWorksCount(item) > LICENSOR_WORK_PREVIEW_LIMIT
        },
        isShowAllLicensorWorks(item) {
            return !!(item && item.alvId && this.showAllWorksByLicensor[item.alvId])
        },
        showAllWorksLabel(item) {
            if (this.isShowAllLicensorWorks(item)) {
                const key = 'lang_GENERIC_CAPTION_SHOW_LESS'
                const translated = this.$t(key)
                return translated === key ? 'Show less' : translated
            }
            return this.$t('lang_GENERIC_CAPTION_SHOW_ALL')
        },
        toggleShowAllLicensorWorks(item) {
            if (!item || !item.alvId) return
            this.$set(this.showAllWorksByLicensor, item.alvId, !this.showAllWorksByLicensor[item.alvId])
        },
        visibleLicensorWorks(item) {
            const works = (item && item.works) ? item.works : []
            if (this.isShowAllLicensorWorks(item) || works.length <= LICENSOR_WORK_PREVIEW_LIMIT) {
                return works
            }
            const top = works.slice(0, LICENSOR_WORK_PREVIEW_LIMIT)
            const rest = works.slice(LICENSOR_WORK_PREVIEW_LIMIT)
            const othersKey = 'lang_GENERIC_CAPTION_OTHERS'
            const translated = this.$t(othersKey)
            const othersName = (translated === othersKey ? 'Others' : translated) + ' (' + rest.length + ')'
            return top.concat([{
                alvId: '__others__',
                title: othersName,
                isOthers: true,
                pr: rest.reduce((sum, work) => sum + (Number(work.pr) || 0), 0),
                mr: rest.reduce((sum, work) => sum + (Number(work.mr) || 0), 0),
                sum: rest.reduce((sum, work) => sum + (Number(work.sum) || 0), 0),
            }])
        },
        exportExcel() {
            const from = this.$store.getters.getSelectedPublishingStatisticsFrom
            const to = this.$store.getters.getSelectedPublishingStatisticsTo
            if (!from || !to) {
                this.$store.commit('setSnackbar', {
                    type: 'error',
                    msg: this.$t('lang_GENERAL_CAPTION_PLEASE_SELECT_PERIOD'),
                })
                return
            }
            this.$store.dispatch('publishingStatisticsExportExcel')
        },
    },
    created() {
        this.$store.commit('setPublishingContractsTypes')
        this.$store.dispatch('fetchPublishingStatisticsFavoriteDropdownValues')
        if (
            this.$store.getters.getAzForMappingsImport.length === 0 ||
            this.$store.getters.getAzForMappingsExport.length === 0
        ) {
            this.$store.dispatch('fetchAzForMappings')
        }
    },
}
</script>
